<template>
  <v-container fluid class="fill-height">
    <v-row v-if="loadingRecords" justify="center" align="center">
      <v-progress-circular indeterminate :size="60" color="primary" />
    </v-row>

    <v-row v-else-if="APIError" justify="center" align="center">
      <p>
        <v-icon color="error">mdi-alert-circle-outline</v-icon> Sorry, something
        went wrong. Please try again later.
      </p>
    </v-row>

    <MoodDiaryCard
      v-else
      v-for="record in displayedMoodDiaryRecords"
      :key="record.id"
      :record="record"
      @edit-record="editRecord"
      @delete-record="deleteRecord"
    />

    <v-row
      v-if="numberOfRecordsToDisplay < moodDiaryRecords.length"
      justify="center"
      align="center"
    >
      <v-btn
        class="mb-2"
        @click="increaseNumberOfRecordsToDisplay"
        color="primary"
        >Load More</v-btn
      >
    </v-row>

    <v-btn bottom color="green" dark fab fixed right @click="createNewRecord">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="800px">
      <MoodDiaryForm
        :key="dialogKey"
        :propsRecord="selectedRecord"
        :recordedDates="recordedDates"
        :action="dialogAction"
        @close-dialog="closeDialog"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

import { mapState } from 'vuex'

import MoodDiaryForm from "./MoodDiaryForm";
import MoodDiaryCard from "./MoodDiaryCard";

export default {
  name: "MoodDiary",

  components: {
    MoodDiaryForm,
    MoodDiaryCard
  },

  data: () => ({
    dialog: false,
    dialogAction: "create",
    selectedRecord: undefined,
    APIError: false,
    dialogKey: "",
    loadingRecords: false,
    numberOfRecordsToDisplay: 7
  }),

  mounted() {
    if (this.moodDiaryRecords.length == 0) {
      this.getRecords()
    }
  },

  computed: {
    ...mapState([
      'moodDiaryRecords'
    ]),
    recordedDates: function () {
      return this.moodDiaryRecords.map(record => record.date)
    },
    displayedMoodDiaryRecords: function () {
      return this.moodDiaryRecords.slice(0, this.numberOfRecordsToDisplay)
    }
  },

  methods: {
    getRecords: function () {
      this.loadingRecords = true
      this.APIError = false
      axios
        .get(
          `${process.env.VUE_APP_API_ROOT_URL}mood/records/`,
          this.$store.getters.axiosConfig
        )
        .then(response => {
          this.$store.commit("updateMoodDiaryRecords", response.data)
          this.loadingRecords = false
        })
        .catch(() => {
          this.APIError = true
          this.loadingRecords = false
        });
    },
    createNewRecord: function () {
      this.selectedRecord = undefined
      this.dialogAction = "create"
      this.openDialog()
    },
    editRecord: function (record) {
      this.selectedRecord = record
      this.dialogAction = "edit"
      this.openDialog()
    },
    deleteRecord: function (record) {
      this.selectedRecord = record
      this.dialogAction = "delete"
      this.openDialog()
    },
    openDialog: function () {
      this.dialogKey = this.selectedRecord ? this.selectedRecord.id : "new"
      this.dialog = true
    },
    closeDialog: function () {
      this.dialogKey = ""
      this.dialog = false
    },
    increaseNumberOfRecordsToDisplay: function () {
      this.numberOfRecordsToDisplay += 7
    }
  }
};
</script>
